import { type CssResponsiveVariables, type Pixels } from './types';

/** Numeric grid gap in px — keep in sync with `--grid-gap` in `gridCssResponsiveVariables`. */
export const GRID_GAP_PX = 10 as const;

export interface GridCssResponsiveVariables {
    '--grid-item-default-column-size'?: number;
    '--grid-item-default-row-size'?: number;
    '--grid-columns'?: number;
    '--grid-padding'?: Pixels;
    '--grid-gap'?: Pixels;
}

export const gridCssResponsiveVariables: CssResponsiveVariables<GridCssResponsiveVariables> = {
    'mobile.sm': {
        '--grid-item-default-column-size': 2, // @TODO: not updated to this project yet
        '--grid-item-default-row-size': 1, // @TODO: not updated to this project yet
        '--grid-columns': 12,
        '--grid-padding': `${GRID_GAP_PX}px`,
        '--grid-gap': `${GRID_GAP_PX}px`,
    },
    'mobile.md': {},
    'mobile.lg': {},
    'tablet.sm': {},
    'tablet.lg': {
        '--grid-item-default-column-size': 3, // @TODO: not updated to this project yet
        '--grid-item-default-row-size': 1, // @TODO: not updated to this project yet
        '--grid-columns': 24,
        '--grid-padding': `${GRID_GAP_PX}px`,
        '--grid-gap': `${GRID_GAP_PX}px`,
    },
    'desktop.sm': {},
    'desktop.md': {},
    'desktop.lg': {},
};
